import React from 'react';
// import used components
import StatsPanel from '../StatsPanel'
// import component styles
import './style.css';

function AsidePanel() {
  return (
    <div id="AsidePanel"> 
      <StatsPanel />
    </div>
  );
}

export default AsidePanel;